import { get } from '../../../common/request/http';
import { handleStockData } from './handle';
import { handleStockDataPerformance } from './handle-stockList';
import { DaXinKeTangDataType } from  './type'
// 接口module参数
import { moduleType } from '../common/constant';
// 空数据
const errData = {
  data: {
    stock: null,
    bond: null,
  }
}

// 获取服务器时间和开盘状态
export async function getServeDate() {
  const url = '/dataapi/limit_up/trade_status';
  try {
    const data: any = await get(url);
    return data.data;
  } catch (error) {
    return {
      stat: '',
      timestamp: '',
    };
  }
}

// 获取A股今日申购，即将申购，中签数据
export async function getAStockBuyMessage(params: any) {
  const url = '/dataapi/new_stock_calendar/v2/base_info';
  let data: any = null
  try {
    data = await get(url, params);
  } catch (error) {
    data = errData;
  }
  if (data && data.status_code === 0) {
    return handleStockData(data.data, params.module);
  }
  return handleStockData(errData.data, params.module);
}

// 获取A股待上市数据
export async function getAWillListedData() {
  const url = '/dataapi/new_stock_calendar/v2/base_info';
  let data: any = null
  try {
    data = await get(url, { module: moduleType.WAITLISTING });
    if (data && data.status_code === 0) {
      return handleStockDataPerformance(data.data, moduleType.WAITLISTING);
    }
    return errData.data;
  } catch (error) {
    return {
      stock: null,
      bond: null
    }
  }
}

// 获取A股上市表现数据
export async function getAListedData(type: string, params: any) {
  const url = '/dataapi/new_stock_calendar/v2/performance';
  let data: any = null
  try {
    data = await get(url, params);
    if (data && data.status_code === 0) {
      return handleStockDataPerformance(data.data, type);
    }
    return errData.data;
  } catch (error) {
    return {
      stock: null,
      bond: null
    }
  }
}

// 请求新三板今日申购，即将申购，中签数据
export async function getNewThreeBuyMessage(params: any) {
  const url = '/dataapi/new_stock_calendar/v2/neeq_base_info';
  let data: any = null
  try {
    data = await get(url, params);
  } catch (error) {
    data = errData;
  }
  if (data && data.status_code === 0) {
    return handleStockData({
      stock: data.data,
      bond: [],
    }, 'new_plate');
  }
  return handleStockData({
    stock: [],
    bond: [],
  }, 'new_plate');
}

// 获取新三板待上市数据
export async function getNewThreeWillListedData() {
  const url = '/dataapi/new_stock_calendar/v2/neeq_base_info';
  let data: any = null
  try {
    data = await get(url, { module: moduleType.WAITLISTING });
    if (data && data.status_code === 0) {
      return handleStockDataPerformance({
        stock: data.data,
        bond: [],
        page: data.data.page
      }, 'new_plate_wait_listing');
    }
    return errData.data;
  } catch (error) {
    return {
      stock: null,
      bond: null
    }
  }
}

// 获取新三板上市表现数据
export async function getNewThreePlateListedData(params: any) {
  const url = '/dataapi/new_stock_calendar/v2/neeq_performance';
  let data: any = null
  try {
    data = await get(url, params);
    if (data && data.data && data.status_code === 0) {
      return handleStockDataPerformance({
        stock: data.data.info,
        bond: [],
        page: data.data.page
      }, 'new_plate_listed_performance');
    }
    return errData.data;
  } catch (error) {
    return {
      stock: null,
      bond: null
    }
  }
}

//获取打新课堂入口和
export async function getInfoOfdxkt(){
  const url = '//eq.10jqka.com.cn/open/api/dynamic_configuration/v1/config_list?key=daxinketang';
  let data:DaXinKeTangDataType | null = null;
  try{
    const res:any = await get(url);
    if (res && res.status_code === 0) {
       data  = res.data;
    }
    return data;
  }catch(error){
    window.console.log('error',error);
    return data;
  }
}